module.exports = __webpack_public_path__ + "img/zelle.843ce34f.svg";